export default {
    // 获取地址栏的某个参数值
    getParams(search) {
        let str = location.search;
        let searchParams = [];
        if (str) {
            str = str.substr(1);
            let aStr = str.split('&'),
                aTemp = [];
            for (let i = 0; i < aStr.length; i++) {
                aTemp = aStr[i].split('=');
                searchParams[aTemp[0]] = aTemp[1];
            }
        }
        return searchParams[search];
    },
    getCookie(name) {
        var arr,
            reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
        if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
        else return '';
    },
    setCookie(name, value, days) {
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            var expires = '; expires=' + date.toGMTString();
        } else {
            var expires = '';
        }
        document.cookie =
            name + '=' + value + expires + '; path=/;domain=qq.com';
    },
    delCookie(name, domain = 'qq.com') {
        var exp = new Date();
        exp.setTime(exp.getTime() - 1);
        var cval = this.getCookie(name);
        if (cval != '')
            document.cookie =
                name +
                '=' +
                cval +
                ';expires=' +
                exp.toGMTString() +
                '; path=/;domain=.' +
                domain;
    },
    /**
     * 存储sessionStorage
     */
    setSessionStore(name, content) {
        if (!name) return;
        if (typeof content !== 'string') {
            content = JSON.stringify(content);
        }
        window.sessionStorage.setItem(name, content);
    },

    /**
     * 获取sessionStorage
     */
    getSessionStore(name) {
        if (!name) return;
        let value = window.sessionStorage.getItem(name);
        if (!value || value == '') {
            return '';
        }
        return value;
    },

    /**
     * 删除sessionStorage
     */
    removeSessionStore(name) {
        if (!name) return;
        window.sessionStorage.removeItem(name);
    },
    /**
     * 存储localStorage
     */
    setLocalStore(name, content) {
        if (!name) return;
        if (typeof content !== 'string') {
            content = JSON.stringify(content);
        }
        window.localStorage.setItem(name, content);
    },

    /**
     * 获取localStorage
     */
    getLocalStore(name) {
        if (!name) return;
        let value = window.localStorage.getItem(name);
        if (!value || value == '') {
            return null;
        }
        return value;
    },

    /**
     * 删除localStorage
     */
    removeLocalStore(name) {
        if (!name) return;
        window.localStorage.removeItem(name);
    },

    /**
     * 日期格式化
     */
    formatDate(time, connect = '') {
        if (typeof time == 'string' && time.includes('-')) {
            time = time.split('-').join('/');
        }
        time = new Date(time);
        return `${time.getFullYear()}${connect}${
            time.getMonth() + 1 < 10
                ? '0' + (time.getMonth() + 1)
                : (time.getMonth() + 1).toString()
        }${connect}${
            time.getDate() < 10
                ? '0' + time.getDate()
                : time.getDate().toString()
        }`;
    },
    getCurrentDate(connect = '-') {
        let time = new Date();
        return `
		${time.getFullYear()}${connect}${
            time.getMonth() + 1 < 10
                ? '0' + (time.getMonth() + 1)
                : (time.getMonth() + 1).toString()
        }${connect}${
            time.getDate() < 10
                ? '0' + time.getDate()
                : time.getDate().toString()
        }
		${time.getHours()}:${time.getMinutes()}:${time.getSeconds()}`;
    },
    toThousandsFilter(num) {
        if (typeof num == 'undefined') {
            return '';
        }
        let cent = 2;
        num = num.toString().replace(/\$|\,/g, '');
        // 检查传入数值为数值类型
        if (isNaN(num)) num = '0';
        // 获取符号(正/负数)
        let sign = num == (num = Math.abs(num));
        num = Math.floor(num * Math.pow(10, cent) + 0.50000000001); // 把指定的小数位先转换成整数.多余的小数位四舍五入
        let cents = num % Math.pow(10, cent); // 求出小数位数值
        num = Math.floor(num / Math.pow(10, cent)).toString(); // 求出整数位数值
        cents = cents.toString(); // 把小数位转换成字符串,以便求小数位长度
        // 补足小数位到指定的位数
        while (cents.length < cent) cents = '0' + cents;

        // 对整数部分进行千分位格式化.
        for (let i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
            num =
                num.substring(0, num.length - (4 * i + 3)) +
                ',' +
                num.substring(num.length - (4 * i + 3));

        if (cent > 0) return (sign ? '' : '-') + num + '.' + cents;
        else return (sign ? '' : '-') + num;
    },
    paramsConnect(params) {
        let paramStr = '';
        Object.keys(params).forEach(item => {
            paramStr += '&' + item + '=' + encodeURIComponent(params[item]);
        });
        return paramStr.slice(1);
    },
    dataReport(area, params) {
        let pic = new Image();
        let query = this.paramsConnect(params);
        try {
            pic.src = `//itea-stat.qq.com/tgl/${area}?${query}`;
        } catch (err) {
            console.log(err);
        }
    },
    reportVideoUpload(startTime, fileSize, code) {
        this.dataReport('videoupload', {
            req_time: Date.now() - startTime,
            video_size: parseInt(fileSize / 1024 / 1024),
            result_code: code,
            host: window.location.host
        });
    },
    reportContribute(
        success,
        err_msg,
        edit_times,
        deliversource,
        req_time,
        total_sec
    ) {
        this.dataReport('createarticle', {
            host: window.location.host,
            success: success, // 0=失败，1=成功
            err_msg: err_msg, // 错误信息（需要urlencode）
            edit_times: edit_times, // 发布按钮点击次数(组件加载时清零)
            deliversource: deliversource, // 投稿类型，order=订单，ugc=自由投稿，activity=活动，task=任务投稿，special=专版投稿
            req_time: Date.now() - req_time, // 请求耗时ms
            total_sec: Date.now() - total_sec // 编辑时间s(组件加载时清零)
        });
    }
};
